import { useNavigate } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import { useListManager } from "../../contexts/list.manager";

export function BackButton({ route = null, ...props }) {
   const navigate = useNavigate();
   const { setLineSelected } = useListManager();

   function handleBack() {
      setLineSelected(null);
      if (route) {
         navigate(route);
         return;
      }
      if (window.history.state && window.history.state.idx > 0) {
         navigate(-1);
      } else {
         navigate('/', { replace: true });
      }
   }

   return (
      <button type="button" className="back-button" onClick={(e) => handleBack()}>
         <IoArrowBackOutline />
         Voltar
      </button>
   );
}